export enum DatiqRulesIsTypes {
    Equals = 'equals',
    NotEquals = 'notEquals',
    GreaterThan = 'gt',
    GreaterThanEqual = 'gte',
    LessThan = 'lt',
    LessThanEqual = 'lte',
    Contains = 'contains',
    Earlier = 'earlier',
    Later = 'later',
}

export enum DatiqRulesConditionOperators {
    And = 'and',
    Or = 'or',
    Not = 'not',
}

export enum DatiqRulesRelations {
    All = 'all',
    Some = 'some',
    None = 'none',
}
